angular.module('env.data.models.orderModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("OrderModel",
            {
                extend: ['BaseModel', 'CustomFieldAwareModel'],
                url: "orders",
                fields: {
                    centreId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    customerId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    deliveryAddressId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    completed: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    reference: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    summary: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    createdBy: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    expectedBy: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    requiredBy: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    value: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    archiveJobLogEntryId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    jsonData: {
                        type: RepresentationModelFieldTypes.DYNAMIC,
                        decode: function (value) {
                            return value ? JSON.parse(value) : null;
                        },
                        encode: function (value) {
                            return value ? JSON.stringify(value) : null;
                        }
                    },
                    customer: {
                        subResource: true,
                        get: function (rest, model) {
                            if (model.$model.customerId) {
                                return rest
                                    .map(rest.getDefinition("CustomerModel"))
                                    .map(model.$model.customerId)
                                    .willReturn("CustomerModel", model.$model.customerId).get();
                            }
                            return null;
                        }
                    },
                    centre: {
                        subResource: true,
                        get: function (rest, model) {
                            if (model.$model.centreId) {
                                return rest
                                    .map(rest.getDefinition("CentreModel"))
                                    .map(model.$model.centreId)
                                    .willReturn("CentreModel", model.$model.centreId)
                                    .get();
                            }
                            return null;
                        }
                    },
                    deliveryAddress: {
                        subResource: true,
                        get: function (rest, model) {
                            if (model.$model.deliveryAddressId) {
                                return rest
                                    .map(rest.getDefinition("AddressModel"))
                                    .map(model.$model.deliveryAddressId)
                                    .willReturn("AddressModel", model.$model.deliveryAddressId).get();
                            }
                            return null;
                        }
                    }
                }
            }
        );
    })

;